var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _rect6, _rect7, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect8, _path1, _path10, _circle, _path11, _path12, _path13, _circle2, _path14, _circle3, _circle4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 617.83 640.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ebcc8a;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #bdbcbc;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 287.5,
    y: 79.28,
    width: 25,
    height: 103.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 237.5,
    y: 445.25,
    width: 25,
    height: 122.61
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 237.5,
    y: 40.48,
    width: 25,
    height: 114.24
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.96,
    y: 325,
    width: 110.19,
    height: 25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.3,
    y: 250,
    width: 112.85,
    height: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300,200c46.6,0,85.75,31.87,96.85,75h25.65c-11.58-57.06-62.02-100-122.5-100s-110.92,42.94-122.5,100h25.65c11.1-43.13,50.25-75,96.85-75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300,400c-46.6,0-85.75-31.87-96.85-75h-25.65c11.58,57.06,62.02,100,122.5,100s110.92-42.94,122.5-100h-25.65c-11.1,43.13-50.25,75-96.85,75Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 396.85,
    y: 250,
    width: 115.08,
    height: 25
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 396.85,
    y: 325,
    width: 108.15,
    height: 25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125,300c0,17.38,2.54,34.16,7.26,50h26.29c-5.53-15.64-8.55-32.47-8.55-50s3.01-34.36,8.54-50h-26.28c-4.72,15.84-7.26,32.62-7.26,50Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.5,154.73v-25.68c-53.43,11.67-97.74,47.75-120.65,95.96h28.21c19.89-34.38,53.03-60.13,92.43-70.27Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,300c0-17.27,2.2-34.02,6.31-50h-25.73c-3.65,16.08-5.58,32.81-5.58,50s1.94,33.92,5.58,50h25.72c-4.11-15.98-6.3-32.73-6.3-50Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.81,225h26.74c23.15-57.18,71.98-101.19,132.19-117.79v-25.85c-74.08,17.98-133.83,72.62-158.93,143.64Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.35,309.51c-3.85-101.04,52.83-190.34,137.64-232.97l-13.38-21.26C82.52,102.61,21.17,200.18,25.37,310.47c3.94,103.35,64.43,191.19,150.56,234.9l9.11-23.43c-77.13-40.1-131.14-119.33-134.69-212.42Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,25c-21.5,0-42.42,2.47-62.5,7.14v25.74c19.98-5.14,40.92-7.88,62.5-7.88,138.07,0,250,111.93,250,250s-111.93,250-250,250c-21.58,0-42.52-2.73-62.5-7.88v25.74c20.08,4.67,41,7.14,62.5,7.14,151.88,0,275-123.12,275-275S451.88,25,300,25Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.07,375h-28.22c22.91,48.22,67.21,84.3,120.65,95.97v-25.72c-39.4-10.14-72.54-35.88-92.43-70.25Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.55,375h-26.73c26.86,75.99,93.37,133.23,174.68,146.88v-25.4c-67.39-12.79-122.81-59.38-147.95-121.48Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 287.5,
    y: 411.79,
    width: 25,
    height: 112.86
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300,125c-4.2,0-8.37.16-12.5.45v25.07c4.12-.34,8.29-.52,12.5-.52,55.52,0,103.99,30.17,129.93,75h28.22c-28.09-59.12-88.34-100-158.15-100Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300,450c-4.21,0-8.38-.19-12.5-.53v25.09c4.13.29,8.3.44,12.5.44,69.81,0,130.06-40.88,158.15-100h-28.22c-25.94,44.83-74.41,75-129.93,75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 189.06,
    cy: 62.09,
    r: 23.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300,75c-4.2,0-8.36.12-12.5.35v25.05c4.14-.26,8.3-.4,12.5-.4,52.28,0,99.88,20.07,135.51,52.92l20.91-14.64c-40.49-39.17-95.63-63.28-156.42-63.28Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300,500c-4.2,0-8.37-.14-12.5-.39v25.04c4.14.23,8.3.35,12.5.35,43.54,0,84.18-12.38,118.62-33.79l-14.36-20.51c-30.36,18.58-66.06,29.3-104.26,29.3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M525,300c0-43.54-12.38-84.18-33.79-118.62l-20.51,14.36c18.58,30.36,29.3,66.06,29.3,104.26,0,53.6-21.09,102.28-55.42,138.19l14.59,20.84c40.68-40.71,65.83-96.93,65.83-159.03Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 189.06,
    cy: 537.91,
    r: 23.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.99,290.48c-3.85-101.04-67.16-185.77-154.96-221.83l11.72-22.21c95.42,40.18,164.02,132.8,168.22,243.09,3.94,103.35-49.7,195.54-132.25,245.67l-10.87-22.67c73.86-45.85,121.68-128.96,118.14-222.05Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 450.26,
    cy: 149.74,
    r: 23.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 450.26,
    cy: 450.26,
    r: 23.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 253.75,
    y: 245,
    width: 20,
    height: 110
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 290,
    y: 239.88,
    width: 20,
    height: 120.23,
    transform: "translate(717.76 373.98) rotate(145.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 326.25,
    y: 245,
    width: 20,
    height: 110
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1880429f56108e8da64321f2a6667c07.svg";
export { ForwardRef as ReactComponent };